import { useQuery } from "@tanstack/react-query";
import { useNavigate } from "react-router-dom";

import { get } from "api";
import { PersonalisationIntro } from "modules/personalisation/components/PersonalisationIntro";
import { PersonalisationAdvisorBenefitsContainer_PATH } from "modules/personalisation/containers/PersonalisationAdvisorBenefitsContainer";
import { PersonalisationWelcomeContainer_PATH } from "modules/personalisation/containers/PersonalisationWelcomeContainer";

export const PersonalisationIntroContainer_PATH = "/personalise/intro" as const;

export const PersonalisationIntroContainer = () => {
  const navigate = useNavigate();

  const { data: platform } = useQuery({
    queryKey: ["/platform"],
    queryFn: () => get("/platform"),
  });

  return (
    <PersonalisationIntro
      platformLogoUrl={platform?.logoImageUrl || ""}
      onBegin={() => navigate(PersonalisationAdvisorBenefitsContainer_PATH)}
      onSkip={() => navigate(PersonalisationWelcomeContainer_PATH)}
    />
  );
};
